import todo from '../images/todo.png';
import portfolio from '../images/portfolio.png';

const projects = [
  {
    title: 'Todo App',
    description:
      'Full-stack MERN todo application featuring task creation, editing, status filtering, and persistent state management.',
    skills: ['React', 'Node.js', 'Express', 'MongoDB'],
    image: todo,
    alt: 'Interactive web dashboard preview of Todo App showing task list management interface.',
    links: {
      github: 'https://github.com/Xin1337/todosapp',
      preview: 'https://todosapp-g41e.onrender.com/',
    }
  },
  {
    title: 'Portfolio',
    description:
      'Personal portfolio website built with React and Sass featuring dynamic terminal profile, decode text, and dark UI.',
    skills: ['React', 'Express', 'Node.js'],
    image: portfolio,
    alt: 'Dark themed portfolio homepage showcase featuring terminal profile and project cards.',
    links: {
      github: 'https://github.com/Xin1337/react-express',
      preview: 'https://xin7331.vercel.app/',
    },
  },
  {
    title: 'AQW Username Checker',
    description:
      'Multi-threaded username availability checker built with headless browser automation, worker threads, and caching.',
    skills: ['Node.js', 'Worker Threads', 'Puppeteer'],
    image: 'https://opengraph.githubassets.com/1/Xin1337/Xin',
    alt: 'GitHub repository social preview card for AQW Username Checker tool.',
    links: {
      github: 'https://github.com/Xin1337/Xin',
    },
  }
];

export default projects;
